import React, { useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import 'offline-js';
import OfflineTheme from './OfflineTheme';
import OfflineLanguageEnglish from './OfflineLanguageEnglish';
import { errorLogger } from '../../utils/trackingUtil';

const OfflineBanner = ({ appOffline, appOnline }) => {
  const { isSingleProblemView, productTypeSmall } = useSelector(
    state => ({
      isSingleProblemView: state.appStatus.isSingleProblemView,
      productTypeSmall: state.test.productTypeSmall,
    }),
    shallowEqual
  );
  const offlineAtRef = useRef(null);
  Offline.options = {
    reconnect: {
      delay: 5,
      initialDelay: 5,
    },
    // Disable offlinejs from storing and resending api call upon internet reconnection
    // ref:https://github.hubspot.com/offline/
    requests: false,
  };
  useEffect(() => {
    Offline.on('down', () => {
      // Offline logic
      offlineAtRef.current = new Date();
      appOffline();
    });

    Offline.on('up', () => {
      // Online logic
      const onlineAt = new Date();
      const offlineError = new Error(
        `app is online now, it was offline from ${offlineAtRef.current?.toString() ??
          'unknown'} to ${onlineAt.toString()}`
      );
      errorLogger(offlineError, {
        offlineAt: offlineAtRef.current?.getTime() ?? null,
        onlineAt: onlineAt.getTime(),
      });
      offlineAtRef.current = null;
      appOnline();
    });

    return () => {
      Offline.off('down');
      Offline.off('up');
    };
  }, [appOffline, appOnline]);

  return (
    <>
      <OfflineTheme isSingleProblemView={isSingleProblemView} />
      <OfflineLanguageEnglish productTypeSmall={productTypeSmall} />
    </>
  );
};

export default OfflineBanner;
